import {
  ConfluenceFolderAriResourceOwner,
  ConfluenceFolderAriResourceType
} from "./chunk-NKU7GI3A.mjs";
import {
  RegisteredAri
} from "./chunk-AB4PPISI.mjs";
import {
  AriParser
} from "./chunk-S7RIZVFI.mjs";

// src/confluence/folder/manifest.ts
var confluenceFolderAriStaticOpts = {
  qualifier: "ari",
  platformQualifier: "cloud",
  cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
  // eslint-disable-line no-useless-escape
  resourceOwner: ConfluenceFolderAriResourceOwner,
  resourceType: ConfluenceFolderAriResourceType,
  resourceIdSlug: "activation/{activationId}/{folderId}",
  resourceIdSegmentFormats: {
    activationId: /[a-zA-Z0-9\-]+/,
    // eslint-disable-line no-useless-escape
    folderId: /[0-9]+/
    // eslint-disable-line no-useless-escape
  }
};

// src/confluence/folder/index.ts
var ConfluenceFolderAri = class _ConfluenceFolderAri extends RegisteredAri {
  constructor(opts) {
    super(opts);
    this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._folderId = opts.resourceIdSegmentValues.folderId;
  }
  get siteId() {
    return this._siteId;
  }
  get activationId() {
    return this._activationId;
  }
  get folderId() {
    return this._folderId;
  }
  static create(opts) {
    let derivedOpts = {
      qualifier: confluenceFolderAriStaticOpts.qualifier,
      platformQualifier: confluenceFolderAriStaticOpts.platformQualifier,
      cloudId: opts.siteId,
      resourceOwner: confluenceFolderAriStaticOpts.resourceOwner,
      resourceType: confluenceFolderAriStaticOpts.resourceType,
      resourceId: `activation/${opts.activationId}/${opts.folderId}`,
      resourceIdSegmentValues: {
        activationId: opts.activationId,
        folderId: opts.folderId
      }
    }, ariOpts = AriParser.fromOpts(derivedOpts, confluenceFolderAriStaticOpts);
    return new _ConfluenceFolderAri(ariOpts);
  }
  static parse(maybeAri) {
    let opts = AriParser.fromString(maybeAri, confluenceFolderAriStaticOpts);
    return new _ConfluenceFolderAri(opts);
  }
  getVariables() {
    return {
      siteId: this.siteId,
      activationId: this.activationId,
      folderId: this.folderId
    };
  }
};

export {
  ConfluenceFolderAri
};
